export default "__VITE_ASSET__qb8kYUTu__"